import { connect } from 'react-redux';
import { connectModal } from 'redux-modal';
import { compose } from 'redux';
import { hide } from 'js/store/actions/modal';
import SelectSourcesRegionalModal from 'js/components/organisms/Modals/SelectSourcesRegionalModal';
export default compose(connect(null, function (dispatch, ownProps) {
  return {
    modalClose: function modalClose() {
      dispatch(hide('SelectSourcesRegionalModal'));
    }
  };
}), connectModal({
  name: 'SelectSourcesRegionalModal',
  destroyOnHide: false
}))(SelectSourcesRegionalModal);